<mh-alerts-wrapper>

  <section mhFilterBar>
    <div mhFilterGroup>
      <div>
        <mh-core-lib-datepicker
          [currentDates]="currentDates"
          [currentFilter]="currentFilterDate"
          (datepickerUpdated)="handleDatepickerUpdated($event)">
        </mh-core-lib-datepicker>
      </div>
      <ng-container *ngIf="fidelityPermisions.includes('interchain_prestay_summary_result')">
        <mh-core-lib-filter-chain-zone [productId]="productId" (chainChanged)="setChain($event)" [disabled]="!isReady"></mh-core-lib-filter-chain-zone>
        <mh-core-lib-filter-hotels requireSelection [chainFilter]="originalChainFilter" (hotelsChanged)="setHotelsFilter($event)"></mh-core-lib-filter-hotels>
      </ng-container>
    </div>
  </section>
  <mh-box-element [title]="('inter-chain.prestay.summary.title' | translate )" *ngIf="fidelityPermisions.includes('interchain_prestay_summary_result')">
    <mh-chain-prestay-summary [currentDates]="currentDates" [chain]="chainFilter" (isReady)="dataIsReady($event)"></mh-chain-prestay-summary>
  </mh-box-element>

</mh-alerts-wrapper>
